



































import { Component, Vue } from 'vue-property-decorator'
import TinyMCE from '@/components/TinyMCE.vue'
import pretty from 'pretty'
import { Notify } from '@/helpers/Notify'
import { NestApi } from '@/fetch/NestApi'
import type { ParsedContent } from '@/interfaces'
import { WYSIWYGFilter } from '@/helpers/WYSIWYGFilter'

@Component({
  components: {
    TinyMCE,
  },
})
export default class ParserManual extends Vue {
  wysiwygContent: string = null
  contentURL: string = null
  injectJS: string = null
  injectCSS: string = null
  injectHTML: string = null
  callFailed = false
  callInProgress = false
  currentStatusCode = 'idle'
  statusCodes = {
    idle: 'Idle',
    'pull-original-content': 'Pulling content and original screenshot',
    'clean-content-in-editor': 'Cleaning content in Editor',
    'push-clean-content': 'Set clean content and take a screenshot',
  }

  dataOriginal: ParsedContent = null
  dataClean: ParsedContent = null

  public created() {
    this.wysiwygContent = ''
    this.injectJS = 'https://static.webhealer.net/wms1.5/js/content.js'
    this.injectCSS =
`<style>
#innerContent {
  padding: 0 20px;
}
#innerContent p.align-left, #innerContent h1.align-left, #innerContent h2.align-left, #innerContent h3.align-left, #innerContent h4.align-left, #innerContent h5.align-left, #innerContent h6.align-left, #innerContent td.align-left, #innerContent th.align-left, #innerContent div.align-left, #innerContent ul.align-left, #innerContent ol.align-left, #innerContent li.align-left, #innerContent table.align-left, #innerContent audio.align-left, #innerContent video.align-left { text-align: left; }
#innerContent p.align-right, #innerContent h1.align-right, #innerContent h2.align-right, #innerContent h3.align-right, #innerContent h4.align-right, #innerContent h5.align-right, #innerContent h6.align-right, #innerContent td.align-right, #innerContent th.align-right, #innerContent div.align-right, #innerContent ul.align-right, #innerContent ol.align-right, #innerContent li.align-right, #innerContent table.align-right, #innerContent audio.align-right, #innerContent video.align-right { text-align: right; }
#innerContent p.align-center, #innerContent h1.align-center, #innerContent h2.align-center, #innerContent h3.align-center, #innerContent h4.align-center, #innerContent h5.align-center, #innerContent h6.align-center, #innerContent td.align-center, #innerContent th.align-center, #innerContent div.align-center, #innerContent ul.align-center, #innerContent ol.align-center, #innerContent li.align-center, #innerContent table.align-center, #innerContent audio.align-center, #innerContent video.align-center { text-align: center; }
#innerContent img.align-left {float: left; margin: 0 20px 20px 0;}
#innerContent img.align-right {float: right; margin: 0 0 20px 20px;}
#innerContent img.align-center {display: block; margin-left: auto; margin-right: auto;}
#innerContent ul {
  list-style-position: inside;
}
#innerContent ul {
  padding-left: 0;
}
</style>`
  }

  private resetUI() {
    this.wysiwygContent = ''
    this.dataOriginal = null
    this.dataClean = null
  }

  get isValidURL() {
    if (!this.contentURL) return false

    try {
      const url = new URL(this.contentURL)
      return url.protocol === 'http:' || url.protocol === 'https:'
    } catch (_) {
      return false
    }
  }

  private getPrettyHTML(html: string): string {
    return pretty(html)
  }

  private injectOuterDiv(html: string): string {
    return '<div id="innerContent">' + html + '</div>'
  }

  private setCurrentStatus(statusCode: string): void {
    this.currentStatusCode = statusCode
  }

  private haltStatus(): void {
    this.currentStatusCode = 'idle'
  }

  private async fetchOriginalContent() {
    this.resetUI()
    this.callInProgress = true
    this.setCurrentStatus('pull-original-content')
    try {
      this.dataOriginal = await NestApi.getRemoteContent(this.contentURL)
      if (this.dataOriginal.content) {
        this.setCurrentStatus('clean-content-in-editor')
        this.wysiwygContent = this.dataOriginal.contentEditor
      } else {
        this.callInProgress = false
        this.haltStatus()
        Notify.create({
          type: 'error',
          title: 'Something went wrong while extracting content from page...',
          text: this.dataOriginal.error,
        })
      }
      this.callInProgress = false
    } catch (e) {
      this.callInProgress = false
      this.haltStatus()
      console.log('notifying some error ' + e)
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }

  private updateContent(cleanContent) {
    // clean a content
    // const filter = new WYSIWYGFilter(cleanContent)
    // this.wysiwygContent = cleanContent = filter.cleanUpHtml()
    this.wysiwygContent = cleanContent

    if (this.currentStatusCode === 'clean-content-in-editor') {
      this.injectHTML = this.getPrettyHTML(this.injectOuterDiv(cleanContent))
      this.fetchCleanContent()
    }
  }

  private async fetchCleanContent() {
    this.callInProgress = true
    this.setCurrentStatus('push-clean-content')
    try {
      this.dataClean = await NestApi.setRemoteContent(this.contentURL, this.injectCSS + this.injectHTML, this.injectJS)
      if (this.dataClean.content) {
        this.haltStatus()
      } else {
        this.callInProgress = false
        this.haltStatus()
        Notify.create({
          type: 'error',
          title: 'Something went wrong while setting new content ...',
          text: this.dataClean.error,
        })
      }
      this.callInProgress = false
    } catch (e) {
      this.callInProgress = false
      this.haltStatus()
      console.log('notifying some error ' + e)
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }
}
